module.exports = __webpack_public_path__ + "img/australia-female.11877d09.png";